import { render, staticRenderFns } from "./ContainerWidgetItem.vue?vue&type=template&id=561e47c8&scoped=true"
import script from "./ContainerWidgetItem.vue?vue&type=script&lang=js"
export * from "./ContainerWidgetItem.vue?vue&type=script&lang=js"
import style0 from "./ContainerWidgetItem.vue?vue&type=style&index=0&id=561e47c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e47c8",
  null
  
)

export default component.exports